import { render, staticRenderFns } from "./VehicleItem.vue?vue&type=template&id=21d5fb95&"
import script from "./VehicleItem.vue?vue&type=script&lang=js&"
export * from "./VehicleItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports